
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'


export default {
name:"Stick",
components: {
Tab,
TabItem,
Sticky
},
data () {
return {
showSpace: false,
disabled: typeof navigator !== 'undefined' && /iphone/i.test(navigator.userAgent) && /ucbrowser/i.test(navigator.userAgent)
}
},
methods: {
spaceChange () {
this.showSpace = !this.showSpace
this.$nextTick(() => {
this.$refs.sticky.bindSticky()
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/Stick.vue